import { NgModule } from "@angular/core";
import { Provisioning } from "ng/src/app/log-settings/provisioning/provisioning.component";
import { SentinelProvision } from "ng/src/app/log-settings/provisioning/sentinel-provision/sentinel-provision.component";
import { TimezoneSelectorComponent } from "ng/src/app/log-settings/timezone-selector/timezone-selector.component";
import * as LBShared from "ng/src/app/shared/shared.module";
import { SharedModule } from "primeng/api";
import { CommonModule } from "@angular/common";
import { CalendarModule } from "primeng/calendar";
import { CardModule } from "primeng/card";
import { CheckboxModule } from "primeng/checkbox";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { DividerModule } from "primeng/divider";
import { FileUploadModule } from "primeng/fileupload";
import { InputNumberModule } from "primeng/inputnumber";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputTextModule } from "primeng/inputtext";
import { MessageModule } from "primeng/message";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { SlideMenuModule } from "primeng/slidemenu";
import { ButtonModule } from "primeng/button";
import { MenuModule } from "primeng/menu";
import { PanelMenuModule } from "primeng/panelmenu";
import { InplaceModule } from "primeng/inplace";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { DialogModule } from "primeng/dialog";
import { EnterNoteSelectorComponent } from "ng/src/app/log-settings/enter-note-selector/enter-note-selector.component";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TableModule } from "primeng/table";
import { FacilityEditorComponent } from './provisioning/sentinel-provision/facility-editor/facility-editor.component';
import { DoorEditorComponent } from './provisioning/sentinel-provision/door-editor/door-editor.component';

@NgModule({
	declarations: [
		TimezoneSelectorComponent,
		EnterNoteSelectorComponent,
		Provisioning,
		SentinelProvision,
	  FacilityEditorComponent,
	  DoorEditorComponent
	],
	imports: [
		FormsModule,
		CommonModule,
		SharedModule,
		MenuModule,
		SlideMenuModule,
		ButtonModule,
		PanelMenuModule,
		InplaceModule,
		ProgressSpinnerModule,
		DialogModule,
		DropdownModule,
		DividerModule,
		CardModule,
		TableModule,
		InputTextModule,
		ReactiveFormsModule,
		CheckboxModule,
		InputSwitchModule,
		InputNumberModule,
		CalendarModule,
		FileUploadModule,
		ConfirmDialogModule,
		ConfirmPopupModule,
		OverlayPanelModule,
		SharedModule,
		LBShared.SharedModule,
		MessageModule
	]
})
export class LogSettingsModule {}